import React, { FC, useEffect, useState } from "react";
import { loginApi, requestTwoFactorAuthenticationCodeApi } from "api/auth";
import CustomButton from "ui/Button";
import { CustomInput, PasswordInput } from "ui/Input";
import { ICON_NAMES } from "utils/constant";
import { useNavigate } from "react-router";

import "./style.css";
import { useAuthStore, useUserStore } from "../../store";
import ErrorInfo from "ui/ErrorInfo";
import { useTranslation } from "react-i18next";
import { useMenuItemStore } from "store/menuItem";

interface LoginForm {
	email: string;
	password: string;
	rememberMe: boolean;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Login: FC<{}> = () => {
	const { t } = useTranslation();

	const [form, setForm] = useState<LoginForm>({
		email: "",
		password: "",
		rememberMe: false,
	});
	const [errorMessage, setErrorMessage] = useState("");
	const [errors, setErrors] = useState({ email: false, password: false });
	const { setAuth, ...auth } = useAuthStore();
	const { setStore } = useUserStore();
	const navigate = useNavigate();
	const { setMenuItem } = useMenuItemStore();

	const submitLogin = () => {
		setMenuItem([]);
		if (!form.password) {
			setErrorMessage("Password field is required");
			setErrors({ ...errors, password: true });
			return;
		}

		if (!form.email) {
			setErrorMessage("Email field is required");
			setErrors({ ...errors, email: true });
			return;
		}

		if (!EMAIL_REGEX.test(form.email.trim())) {
			setErrorMessage("Please enter a valid email address");
			setErrors({ email: true, password: false });
			return;
		}

		setErrors({ email: false, password: false });
		setErrorMessage("");

		loginApi(form.email, form.password, form.rememberMe)
			.then((response) => {
				setAuth({
					email: form.email,
					isLogin: true,
					twoFactorVerified: !response.twoFactorRequired,
					isVerified: false,
					roles: response.roles,
				});
				setStore(response.roles, response.user);

				if (response.twoFactorRequired) {
					requestTwoFactorAuthenticationCodeApi(form.email).finally(() => {
						navigate("/auth/verification/2fa");
					});
				} else {
					const previousUrl = sessionStorage.getItem("previousUrl");
					navigate(previousUrl ?? "/");
				}
			})
			.catch((err) => {
				if (err?.status === 403) {
					// This  is use during migration
					setErrorMessage(
						"Password is required to be changed, please contact the administrator",
					);
					return;
				}
				if (err?.status === 401) {
					setErrorMessage(
						"Password or email provided is invalid, try different one",
					);
				} else {
					setErrorMessage("Something went wrong, try different one");
				}
			});
	};

	useEffect(() => {
		//	if (auth.isLogin) {
		//		navigate(-1); //
		//	}
	}, [auth.isLogin, navigate]);

	const emailChange = (value: string) => {
		setForm({ ...form, email: value });
	};

	const passwordChange = (value: string) => {
		setForm({ ...form, password: value });
	};

	return (
		<div
			className="app-root"
			style={{
				height: "100dvh",
				backgroundColor: "#004959",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					width: "min(310px, calc(100vw - 32px))",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						marginBottom: "60px",
					}}
				>
					<img
						src={`/icon/${ICON_NAMES.SurofiTransparent}.svg`}
						alt="surofi"
						style={{ marginBottom: "10px" }}
					/>
					<span style={{ color: "white" }}>{t("MyPage")}</span>
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						width: "100%",
					}}
				>
					<CustomInput
						onChange={emailChange}
						value={form.email}
						placeholder="Email"
						style={{ marginBottom: "10px" }}
						className={
							errors.email ? "input-container error" : "input-container"
						}
					/>
					<PasswordInput
						value={form.password}
						setPasswordValidated={(isValidated: boolean) => {}}
						onChange={passwordChange}
						placeholder="Password"
						className="input-container"
						isError={errors.password}
						onKeyDown={(event) => {
							if (event.key === "Enter") {
								event.preventDefault();
								submitLogin();
							}
						}}
					/>
					{/*	<div style={{ marginTop: "20px" }}>*/}
					{/*		<Checkbox*/}
					{/*			value={form.rememberMe}*/}
					{/*			label={t("RememberUnit")}*/}
					{/*			onChange={() =>*/}
					{/*				setForm({ ...form, rememberMe: !form.rememberMe })*/}
					{/*			}*/}
					{/*		/>*/}
					{/*	</div>*/}
				</div>

				<ErrorInfo show={errorMessage !== ""} text={errorMessage} />
				<ErrorInfo show={errors.password} text={errorMessage} />

				<div className="button-containter">
					<CustomButton
						label={t("Login")}
						bgColor="#006980"
						color="white"
						onClick={submitLogin}
					/>

					<CustomButton
						label={t("ForgotPassword")}
						bgColor="#004959"
						color="white"
						onClick={() => navigate("/auth/forgot-password")}
					/>
				</div>
				<div
					style={{
						display: "flex",
						gap: 10,
						justifyContent: "flex-end",
						width: "100%",
						marginTop: "20px",
					}}
				>
					{/*	<span style={{ color: "white" }}>Already have account ? </span>*/}
					{/*	<TextButton*/}
					{/*		text={"Signup"}*/}
					{/*		textStyle={{ color: "blue", marginTop: "3px" }} // Todo: add the right the color*/}
					{/*		onClick={() => navigate("/signup")}*/}
					{/*	/>*/}
				</div>
			</div>
		</div>
	);
};

export default Login;
